/**
 * Web counterpart of lib/supportContact.ts. Vite only exposes VITE_-prefixed
 * variables to import.meta.env; the fallback guarantees the published privacy,
 * terms and account-deletion pages always carry a reachable contact.
 */
export const DEFAULT_SUPPORT_EMAIL = 'decimaldrown@gmail.com';

export const SUPPORT_EMAIL: string = (
  import.meta.env.VITE_SUPPORT_EMAIL || DEFAULT_SUPPORT_EMAIL
).trim();
